import { KobitoUser } from '@app/shared/user/models';

/**
 * Mutation系の権限のいずれかを持っているかどうかをチェックする関数
 */
export function hasAnyMutationPermission(user: KobitoUser): boolean {
  return user.permissions.some((permission) =>
    permission.startsWith('MUTATION_'),
  );
}

export const homeRoutePermissions = {
  showLinkCollection: hasAnyMutationPermission,
};
